import React, { useEffect } from 'react';
import { SongList } from 'app/components/Song';
import { ChakraPageTitle } from 'app/components/Core';
import { useAppDispatch, useAppSelector } from 'app/store';
import { resetSongCountAction } from 'app/store/SongList/slice';
import { ContentContainer } from 'app/components/Core/ChakraContentContainer';
import { Flex, Spacer, Text } from '@chakra-ui/react';
import { ContentContainerType } from 'types/enums';
import { getSongCountSelector } from 'app/store/SongList/selectors';
import { PinnedSongsSection } from 'app/components/PinnedSongsSection';

export const Songs = () => {
  const dispatch = useAppDispatch();
  const count = useAppSelector(getSongCountSelector);

  useEffect(
    () => () => {
      dispatch(resetSongCountAction());
    },
    [dispatch]
  );

  return (
    <ContentContainer type={ContentContainerType.LIST} isViewContent pt={8}>
      {!!count && <PinnedSongsSection />}
      <Flex pb={3} maxHeight="76px" align="center">
        <ChakraPageTitle>All Songs</ChakraPageTitle>
        <Spacer />
        {!!count && (
          <Text
            fontSize="sm"
            fontWeight={500}
            color="M.60"
            data-testid="song-list-count"
          >
            Total:&nbsp;{count}
          </Text>
        )}
      </Flex>
      <SongList />
    </ContentContainer>
  );
};
